export default (serviceData) => {
  if (serviceData) {
    return true;
  }
  return false;
};
